/* ==========================================================================
   UrbexEurope — "El Guardián" (fichas de los packs, Modo Halloween)
   Al tocar o hacer clic en el mapa principal, una figura encapuchada sube
   desde el borde inferior del mapa, mira, se deshace en niebla y deja un
   mensaje con el botón de compra. Una vez por sesión. Sin sonido. No toca
   las miniaturas ni el formulario de compra: solo escucha el clic en el mapa.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = document.getElementById('ue-guardian-cfg');
  var tpl = document.getElementById('ue-guardian-tpl');
  var principal = document.querySelector('.ue-prod__principal');
  if (!cfg || !tpl || !principal) return;

  var CLAVE = 'ue-guardian-visto';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enEditor = !!(window.Shopify && window.Shopify.designMode);
  var unaVez = cfg.dataset.unaVez === 'true';
  var enMarcha = false;

  function yaVisto() {
    try { return window.sessionStorage.getItem(CLAVE) === '1'; } catch (e) { return false; }
  }

  function marcarVisto() {
    try { window.sessionStorage.setItem(CLAVE, '1'); } catch (e) {}
  }

  function botonCompra() {
    return document.querySelector('.ue-prod__form button[name="add"]');
  }

  function prepararMensaje(msg) {
    var real = botonCompra();
    var proxy = msg.querySelector('.ue-guardian-msg__btn');

    if (!real || real.disabled) {
      if (proxy) proxy.remove();
    } else if (proxy) {
      proxy.addEventListener('click', function (ev) {
        ev.stopPropagation();
        real.click();
      });
      if (!reduce) {
        real.classList.add('ue-guardian-resalto');
        setTimeout(function () { real.classList.remove('ue-guardian-resalto'); }, 4300);
      }
    }

    msg.querySelector('.ue-guardian-msg__cerrar').addEventListener('click', function (ev) {
      ev.stopPropagation();
      msg.classList.remove('ue-g-visible');
      setTimeout(function () { msg.remove(); }, 650);
    });

    // Forzar el cálculo de estilos antes de añadir la clase: así el fundido
    // arranca aunque el navegador no pinte el siguiente fotograma enseguida
    void msg.offsetWidth;
    msg.classList.add('ue-g-visible');
  }

  function lanzar() {
    enMarcha = true;
    var viejo = principal.querySelector('.ue-guardian-msg');
    if (viejo) viejo.remove();

    var frag = tpl.content.cloneNode(true);
    var capa = frag.querySelector('.ue-guardian-capa');
    var frente = frag.querySelector('.ue-guardian-frente');
    var msg = frag.querySelector('.ue-guardian-msg');

    if (reduce) {
      principal.appendChild(msg);
      prepararMensaje(msg);
      enMarcha = false;
      return;
    }

    var seccion = principal.closest('.ue-section') || document.body;
    var contenedor = principal.closest('.ue-container') || document.body;

    // Velo de toda la página (un span: Dawn oculta los div vacíos)
    var velo = document.createElement('span');
    velo.className = 'ue-guardian-velo';
    velo.setAttribute('aria-hidden', 'true');

    seccion.classList.add('ue-guardian-escena');
    contenedor.appendChild(velo);
    principal.appendChild(capa);
    principal.appendChild(frente);

    void capa.offsetWidth;
    seccion.classList.add('ue-guardian-play');

    setTimeout(function () {
      principal.appendChild(msg);
      prepararMensaje(msg);
    }, 2350);

    setTimeout(function () {
      capa.remove();
      frente.remove();
      velo.remove();
      seccion.classList.remove('ue-guardian-escena', 'ue-guardian-play');
      enMarcha = false;
    }, 3200);
  }

  principal.classList.add('ue-guardian-objetivo');
  principal.addEventListener('click', function (ev) {
    if (ev.target.closest('.ue-guardian-msg')) return;
    if (enMarcha) return;
    if (unaVez && !enEditor && yaVisto()) return;
    marcarVisto();
    lanzar();
  });
})();
